import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function roleLabel(role: string): string {
  if (role === 'SUPER_ADMIN' || role === 'ADMIN') return 'Administrador';
  if (role === 'MENTOR') return 'Mentor';
  return 'Aluno';
}
